// import PropTypes from 'prop-types'
import React, {useEffect} from 'react'
// import {useDispatch, useSelector} from 'react-redux'
// import {RootState} from 'store'
import styled, {css} from 'styled-components'
import {Box, BoxWrapper, Container} from './styles'

import OurStory_500years_Title from '../../assets/images/OurStory_500years_Title.svg'
import CreatedBlock from '../CreatedBlock'
import Breakpoint from '../../utils/breakpoint'
import Font from '../../utils/Font'
// import progressivelyImages from '../../hooks/image-effect'

const {mobile, desk} = Breakpoint
const chineseLang = ['zh-tw', 'zh-cn']
const otherLangsMap = [...chineseLang]


interface MainContentProps {
  readonly langCode?: string
}
interface LabelProps {
  readonly langCode: string
}
const Wrapper = styled.div<MainContentProps>`
  display: flex;
  gap: 15px;
  flex-direction: ${({langCode}) => (langCode === 'il' ? 'row-reverse' : 'row')};
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 115px;
  @media (max-width: ${mobile}px) {
    display: block;
    padding-bottom: 0;
  }
`

const Aside = styled.div`
  flex: 0 1 50%;
  @media (max-width: 767px) {
    width: 100%;
    min-height: 160vw;
  }
`

const MainContent = styled.div<LabelProps>`
  font-family: ${({langCode}) => Font(langCode).mainFont};
  flex: 0 1 ${({langCode}) => (otherLangsMap.indexOf(langCode) > -1 ? '39%' : '50%')};
  @media (max-width: ${mobile}px) {
    width: 100%;
    flex: 0 1 100%;
    padding-left: 15px;
    padding-right: 15px;
  }
`

const Label = styled.h2<LabelProps>`
  font-size: 44px;
  line-height: 1.1em;
  color: #ffc239;
  margin-bottom: ${({langCode}) => (chineseLang.indexOf(langCode) > -1 ? '40px' : '2vw')};
  ${({langCode}) =>
    chineseLang.indexOf(langCode) > -1 &&
    css`
      margin-top: 50px;
    `}
  ${({langCode}) =>
    otherLangsMap.indexOf(langCode) > -1 &&
    css`
      max-width: 260px;
      line-height: 1.4em;
    `}
  @media (max-width: ${mobile}px) {
    margin-top: 35px;
    margin-bottom: 30px;
    font-size: 35px;
  }
`
const Content = styled.div<LabelProps>`
  font-family: ${({langCode}) => Font(langCode).bodyFont};
  line-height: 1.56;
  color: #fff;
  & p {
    margin-bottom: 2em;
  }
`
const ContentInner = styled.div`
  padding-top: 3vw;
  padding-right: 0;
  padding-bottom: 4vw;
  @media (max-width: ${mobile}px) {
    padding-right: 15px;
    padding-left: 15px;
  }
`
interface IProps {
  miscData: any
  langCode: string
  // onClick(event: React.MouseEvent<HTMLButtonElement>): void
  // ...
}
const SecondSection: React.FC<IProps> = ({miscData, langCode}) => {
  // const dispatch = useDispatch()

  // useEffect(() => {
  //   progressivelyImages()
  // }, [])
  const mainLanguage = otherLangsMap.indexOf(langCode) < 0
  const isChineseLang = chineseLang.indexOf(langCode) > -1

  return (
    <Container className="Image--lazyLoad">
      <Wrapper langCode={langCode}>
        <Aside />
        <MainContent className="a-left" langCode={langCode}>
          <ContentInner>
            {isChineseLang ? (
              <Label langCode={langCode}>
                <Box>
                  <img src={OurStory_500years_Title} />
                </Box>
              </Label>
            ) : (
              <Label dangerouslySetInnerHTML={{__html: miscData['secondTitle']}} langCode={langCode} />
            )}

            <Content className="Paragraph" langCode={langCode} dangerouslySetInnerHTML={{__html: miscData['secondContent']}} />
          </ContentInner>
        </MainContent>
      </Wrapper>
      <CreatedBlock miscData={miscData} langCode={langCode} />
    </Container>
  )
}
// SecondSection.propTypes = {
//   miscData: PropTypes.object,
//   langCode: PropTypes.string,
// }
export default SecondSection
